import React from 'react';
import { connect } from 'react-redux';
import CharChooseBtn from './CharChooseBtn';
import CharBlank from './CharBlank';
import { charSelected } from '../../../actions/char';
import { genCharArray } from '../../../utils/utils';

const charChoose = (WrappedComponent, charType) => {
	class CharChoose extends React.Component {
		constructor(props) {
		    super(props);

		    let charArray;

		    if (charType === 'lc') {
				charArray = genCharArray('a', 'z');
		    }
		    else if (charType === 'uc') {
				charArray = genCharArray('a', 'z', true);
		    }
		    else if (charType === 'num') {
		    	charArray = [];
		    	for (let i = 0; i < 10; i++) {
					charArray[i] = String(i + 1);
		    	}
		    }

		    this.state = {
		    	array: charArray
		    };
	  	}
	    onClick = (e) => {
	    	this.props.charSelected(e.target.id);
		}
		componentWillUnmount() {
			this.props.charSelected(undefined);
		}
	    render() {
	    	let blank;
            if (charType === 'num') {
                blank = '';
            }
            else {
                blank = 
                	[...Array(2)].map((label, index) => {
                        return (
                            <CharBlank key={index} id={index} />
                        );
                    });
            }
	        return (
	            <div id={charType + '-choose'} className="char-choose panel">
			        <div className="title"></div>
			        <div className="panel-arrow-r"></div>
			        <div className="holder">
			            <div className="holder-inner">
			            	{this.state.array.map((label, index) => {
			                    return (
			                        <CharChooseBtn charType={charType} selected={this.props.char === label} key={index} label={label} onClick={this.onClick} />
			                    );
			                })}
			                {blank}
			            </div>
			        </div>
			    </div>
	        );
	    }
	};

	const mapStateToProps = (state) => ({
		char: state.char.char
	})

	const mapDispatchToProps = (dispatch) => ({
		charSelected: (char) => dispatch(charSelected(char))
	});

	return connect(mapStateToProps, mapDispatchToProps)(CharChoose);
}

export default charChoose;



// WEBPACK FOOTER //
// ./src/components/sections/shared/CharChoose.js